export default "__VITE_PUBLIC_ASSET__164e2c79__"